import React from 'react';
import { PropTypes } from 'prop-types';

const Checkbox = ({ name, type, label, checked, onChange, children, ...props }) => {
  return (
    <label>
      <input
        {...props}
        name={name}
        type="checkbox"
        checked={checked}
        onChange={onChange} />
      <span>{label}</span>
    </label>
  );
}

Checkbox.propTypes = {
  checked: PropTypes.bool,
  name: PropTypes.string.isRequired,
  label: PropTypes.string,
  onChange: PropTypes.func.isRequired
};

export default Checkbox;



// WEBPACK FOOTER //
// ./src/components/form/controls/Checkbox.js